<template>
    <div v-if="appIsHydrated" class="clock-buttons-ctn">
        <p class="control">
            <button class="button" :disabled="isClockInButtonDisabled" @click.stop="handleClockIn" :title="clockInTitle">
                <span class="icon">
                    <i class="fa fa-arrow-circle-o-down"></i>
                </span>
            </button>
        </p>
        <p class="control">
            <button class="button" :disabled="isClockOutButtonDisabled" @click.stop="handleClockOut" :title="clockOutTitle">
                <span class="icon">
                    <i class="fa fa-arrow-circle-o-up"></i>
                </span>
            </button>
        </p>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex'
    export default {
        computed: {
            ...mapGetters(['appIsHydrated', 'clocklog']),
            clockInTime() {
                return !!this.clocklog && this.clocklog.clock_in
            },
            clockOutTime() {
                return !!this.clocklog && this.clocklog.clock_out
            },
            isClockInButtonDisabled() {
                return !!this.clockInTime
            },
            isClockOutButtonDisabled() {
                return !this.clockInTime || !!this.clockOutTime
            },
            clockInTitle() {
                return !!this.clockInTime ? `Punched in at ${this.time(this.clockInTime)}` : 'Punch in'
            },
            clockOutTitle() {
                return !!this.clockOutTime ? `Punched out at ${this.time(this.clockOutTime)}` : 'Punch out'
            },
            time() {
                return this.$filters.time
            },
        },
        methods: {
            ...mapActions(['clockIn', 'clockInReminded', 'clocklogGetTodays', 'clockOut']),
            handleClock(type, cb) {
                cb().then(() => {
                    this.$swal.fire({ message: `successful clocked ${type}`, icon: 'success'})
                }, r => {
                    !!r && !!r.message && this.$swal.fire({ message: r.message, icon: 'warning'})
                })
            },
            handleClockIn(e) {
                this.handleClock('in', this.clockIn)
            },
            handleClockOut(e) {
                this.handleClock('out', this.clockOut)
            },
            showReminderMessage() {
                this.clocklogGetTodays().then(clocklog => {
                    if(clocklog && clocklog.reminded) {
                        return
                    }
                    this.alertMessage('Reminder', 'Remember to Punch out')
                    this.clockInReminded()
                })
            },
        },
        mounted() {
            const now = new Date();
            let millisTillRemind = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 17, 0, 0, 0) - now;
            if (millisTillRemind < 0) {
                millisTillRemind = 300000; // try in 5 mins
            }
            setTimeout(() => this.showReminderMessage(), millisTillRemind);
        },
    }
</script>

<style>
.clock-buttons-ctn {
  display: flex;
  margin: 0 8px 0 0; }
.clock-buttons-ctn button[disabled] {
  cursor: auto; }

</style>